import { z } from 'zod';

import type { CreateSimulatedVehicleResponseFE, SimulatedVehicleStatusFE } from '../vehicle';
import { safeOptional } from './restMapping';

/**
 * REST -> domain mapping for simulated vehicles, served by the simulated vehicles endpoint:
 * `POST /simulated-vehicles/api/v1/vehicles` returns `CreateSimulatedVehicleResponse` -> {@link createSimulatedVehicleFromRestV1}.
 * `GET /simulated-vehicles/api/v1/vehicles/:vehicleId` returns `SimulatedVehicleStatus` -> {@link simulatedVehicleStatusFromRestV1}.
 */

const label = (field: string) => `simulatedVehicleFromRestV1.${field}`;

const WireCreateSimulatedVehicleResponseSchema = z.object({
    vehicleId: z.string().min(1),
    operationId: z.string().min(1),
    status: z.string().min(1),
});

const WireSimulatedVehicleStatusSchema = z.object({
    vehicleId: z.string().min(1),
    operationId: safeOptional(z.string(), label('operationId')),
    status: z.string().min(1),
});

export const createSimulatedVehicleFromRestV1 = (raw: unknown): CreateSimulatedVehicleResponseFE => {
    const wire = WireCreateSimulatedVehicleResponseSchema.parse(raw);
    return {
        vehicleId: wire.vehicleId,
        operationId: wire.operationId,
        status: wire.status,
    };
};

export const simulatedVehicleStatusFromRestV1 = (raw: unknown): SimulatedVehicleStatusFE => {
    const wire = WireSimulatedVehicleStatusSchema.parse(raw);
    return {
        vehicleId: wire.vehicleId,
        operationId: wire.operationId ?? undefined,
        status: wire.status,
    };
};
